<template>
    <DxDataGrid id="grid" :show-borders="true" :data-source="contracts" key-expr="ID" :repaint-changes-only="true">
        <DxColumn data-field="number" caption="№ Договора"> </DxColumn>
        <DxColumn data-field="connect_with" caption="С кем договор (наименование)" />
        <DxColumn data-field="kod_abonent" caption="Код абонента" />
        <DxColumn data-field="status" caption="Статус" />
        <DxPaging :page-size="5" />
        <DxPager
            :visible="true"
            :allowed-page-sizes="3"
            display-mode="full"
            :show-page-size-selector="true"
            :show-info="true"
            :show-navigation-buttons="true"
        />
    </DxDataGrid>
</template>

<script setup>
import { inject } from 'vue';
import { DxDataGrid, DxColumn, DxPager, DxPaging } from 'devextreme-vue/data-grid';

const data = inject('serverData');
console.log(data);

const contracts = [
    {
        ID: 1,
        number: '10923 Т',
        connect_with: 'ИП Комиссаренко Валерий Валерьевич',
        kod_abonent: '13456',
        status: 'У',
    },
    {
        ID: 2,
        number: '4523 Т',
        connect_with: 'ИП Комиссаренко Валерий Валерьевич',
        kod_abonent: '13456',
        status: 'А',
    },
    {
        ID: 3,
        number: '165923 Т',
        connect_with: 'ИП Комиссаренко Валерий Валерьевич',
        kod_abonent: '13456',
        status: 'А',
    },
    {
        ID: 4,
        number: '551923 Т',
        connect_with: 'ИП Комиссаренко Валерий Валерьевич',
        kod_abonent: '13456',
        status: 'А',
    },
];
</script>
